
import { observable, action, runInAction } from "mobx";
import { getLabel } from '@weapp/utils';
import { Dialog } from '@weapp/ui';
import { getPhoneFieldData } from '../../../../mock';
import * as SignAPI from '../../../../api/pc/signup';
import { SignParams } from './type';
// import * as API from "../../../api/pc/list";
const { message } = Dialog;

export class SignFormStore {
  // 当前号码段
  @observable currentPhoneField: string = '86';
  @observable phoneFields: [] = [];//号码段列表
  @observable phoneCheck: any = null;//手机校验信息
  @observable mailCheck: any = null;//邮箱校验信息
  @observable ipLimit: boolean = false;//ip注册次数限制
  @observable loading: boolean = false;
  @observable graphcodeCheck: any = {};//验证码状态

  @action
  changeGraphcodeCheck = (checkConfig: any) => {
    this.graphcodeCheck = checkConfig;
  }
  // 获取号码段
  @action
  getPhoneFields = () => {
    this.phoneFields = getPhoneFieldData();
  }
  // 更新当前号码段
  @action
  updatePhoneField = (field: string) => {
    this.currentPhoneField = field;
  }
  @action
  resetForm = () => {
    runInAction(() => {
      this.phoneCheck = null;
      this.mailCheck = null;
      this.currentPhoneField = '86';
      this.ipLimit = false;

    })
  }
  @action
  toSign = (params: SignParams, callback?: () => void) => {
    this.loading = true;
    SignAPI.sign(params).then((result: any) => {
      runInAction(() => {
        this.loading = false;
      })
      if (result?.code !== 200) {
        if (result?.data?.errorMsg) {
          message({
            type: "error",
            content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
          })
          if (result.data.errorMsg.code === 10219) {
            runInAction(() => {
              this.ipLimit = true;
            });
          }
        }
      } else {
        if (result.data) {
          localStorage.setItem('e_userToken', result.data);
          localStorage.setItem('e_account', (params.email || params.mobile) as string);
          localStorage.setItem('e_areaCode', params.areaCode);
        }
        callback && callback();
      }
    });
  }
  openDemoPage = () => {
    SignAPI.logoDemo().then((result: any) => {
      if (result?.data?.errorMsg) {
        message({
          type: "error",
          content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
        })
      } else {
        if (result?.data?.redirectUrl) {
          window.location.href = result.data.redirectUrl;
        }
      }
    });
  }
  @action
  validateMobile = (mobile: string, areaCode?: string) => {

    const params = {
      mobileAccount: mobile,
      areaCode: areaCode || '+86',
    }
    SignAPI.validateMobile(params).then((result: any) => {

      runInAction(() => {
        if (result?.data?.errorMsg) {
          this.phoneCheck = {
            type: 'error',
            content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
          }
        } else {
          this.phoneCheck = {
            type: 'success'
          };
        }

      });
    }).catch((error: any) => {
      console.log(error);
    });
  }

  @action
  validateEmail = (mobile: string) => {
    SignAPI.validateEmail(mobile).then((result: any) => {

      runInAction(() => {
        if (result?.data?.errorMsg) {
          this.mailCheck = {
            type: 'error',
            content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
          }
        } else {
          this.mailCheck = {
            type: 'success'
          };
        }

      });
    }).catch((error: any) => {
      console.log(error);
    });
  }


}
const instance = new SignFormStore();

export default instance;
export type SignFormStoreType = Pick<SignFormStore, keyof SignFormStore>;
